import React, { useState } from "react";
import { Link } from "gatsby";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";

function MobileDropdown({ title, path = "", items, active, lang, toggleMenu }: {toggleMenu:()=>void,lang:string, title: string, path: string, items: any[], active: any }) {
    const [isOpen, setIsOpen] = useState(false);

    function handleToggle() {
        setIsOpen((prev) => !prev);
    }

    return (
        <div className="w-full">
            <Accordion open={isOpen} icon={<ChevronDownIcon className={`h-5 w-5 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />} placeholder={undefined}>
                <AccordionHeader onClick={handleToggle} className={`py-4 text-gray-500 text-xl font-bold transition-all duration-500 underline-offset-8 decoration-2 ${active ? "text-primary" : "hover:text-primary"}`} placeholder={undefined}>
<span className="cap-first">{title}</span>
                </AccordionHeader>
                <AccordionBody>
                    <ul className="list-none flex flex-col gap-1">
                        {items.map((item: any, index: number) => (
                            <li key={index}>
                                <Link to={`/${lang}${item.path}`} onClick={toggleMenu} className="block p-2 text-black rounded font-normal hover:text-primary transition duration-300">
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </AccordionBody>
            </Accordion>
        </div>
    );
}

export default MobileDropdown;
